import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/AuthContext";
import { ThemeProvider, useTheme } from "@/lib/ThemeContext";
import ProtectedRoute from "@/lib/ProtectedRoute";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import StaffGate from "@/pages/StaffGate";
import SmartLinkPage from "@/pages/SmartLinkPage";

function FumettoRedirect() {
  useEffect(() => { window.location.replace("/fumetto.html"); }, []);
  return null;
}
import CookieConsent from "@/components/site/CookieConsent";

function PublicCookieBanner() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/staff")) return null;
  return <CookieConsent />;
}

function AppToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme === "light" ? "light" : "dark"} position="bottom-right" richColors closeButton />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/staff" element={<StaffGate />} />
            <Route path="/smartlink/:slug" element={<SmartLinkPage />} />
            <Route path="/fumetto" element={<FumettoRedirect />} />
          </Routes>
          <PublicCookieBanner />
          <AppToaster />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
